import type { UuidBitmapAsset } from "@common/content/asset/bitmap";
import type { PropElement, PropTypes, PropDefaults } from "@platform/react-storybook/Component";
import Namespace from "./_index.scss";

export const { NAME_POP_UP, TYPE_POP_UP } = Namespace;

export type PropPopUp = PropElement & {
    bitmap: UuidBitmapAsset;
};

export const DEF_POP_UP: PropDefaults<PropPopUp> = {};

export type PropTypesPopUp = PropTypes<PropPopUp, typeof DEF_POP_UP>;
